export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryCovid/theme/components/scorecard/MetricsLabels/index.js